/* Category Auto Complete, taken from http://jqueryui.com/demos/autocomplete/#categories */

$.widget("custom.catcomplete", $.ui.autocomplete, {
	
	BLANK_CATEGORY: 'BLANK_CATEGORY',
	
	_renderMenu: function(ul, items) {
		var self = this;
		var itemsByCat = {};

		$.each(items, function(index, item){
			var cat = item.category ? item.category : self.BLANK_CATEGORY;
			
			if(!itemsByCat[cat]) itemsByCat[cat] = [];
			var c = itemsByCat[cat];
			c.push(item);
		});
		
		ul.addClass('catcomplete');
		if(self.element.attr('id')) ul.addClass('catcomplete-element-id-'+self.element.attr('id'));
		
		for(var cat in itemsByCat){
			if(cat != this.BLANK_CATEGORY) ul.append('<li class="ui-autocomplete-category">' + cat + '</li>');
			for(var i in itemsByCat[cat]){
				var item = itemsByCat[cat][i];
				self._renderItem(ul, item);
			}
		}
	},
	
	_renderItem: function(ul, item){
		return $( "<li></li>" )
		.data( "item.autocomplete", item )
		.append( $( "<a></a>" ).html( item.text ) )
		.appendTo( ul );
	}
	
});